import React from 'react';
import { motion } from 'framer-motion';
import './about.css';

const About = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const features = [
    {
      icon: "🎓",
      title: "Expert Instructors",
      description: "Learn from industry professionals with years of experience"
    },
    {
      icon: "💻",
      title: "Hands-on Learning",
      description: "Practice with real-world projects and assignments"
    },
    {
      icon: "🌟",
      title: "Modern Curriculum",
      description: "Stay updated with the latest technologies and trends"
    },
    {
      icon: "🚀",
      title: "Career Support",
      description: "Get guidance for your professional journey"
    }
  ];

  return (
    <section className="about" id="about">
      <motion.div 
        className="about-header"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2>About Us</h2>
        <p className="about-subtitle">Empowering Students Since 1997</p>
      </motion.div>

      <div className="about-container">
        <motion.div 
          className="about-content"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="about-text">
            <h3>Welcome to Nice Computer Education</h3>
            <p>
              With over 25 years of excellence in computer education, we've been at 
              the forefront of shaping technology careers in Kavali. Our institution 
              combines traditional values with modern teaching methodologies to 
              provide comprehensive learning experiences.
            </p>
            <div className="stats-container">
              <div className="stat-item">
                <span className="stat-number">25+</span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">1000+</span>
                <span className="stat-label">Students Trained</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">50+</span>
                <span className="stat-label">Courses</span>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              className="feature-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h4>{feature.title}</h4>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
